import { z } from 'zod';

import { baseSkillSchema } from './skill';

export const ambitionSchema = baseSkillSchema;
export type Ambition = z.infer<typeof ambitionSchema>;

export const ambitionsSchema = ambitionSchema.array();
export type Ambitions = z.infer<typeof ambitionsSchema>;

export const ambitionOptionsSchema = z.object({
    canEditAmbitions: z.boolean(),
    canReadAmbitions: z.boolean(),
});

export type AmbitionOptions = z.infer<typeof ambitionOptionsSchema>;

export const userAmbitionUpdatePayloadSchema = z.object({
    add: ambitionSchema.pick({ id: true }).required().array(),
    remove: z.string().array(),
});

export type UserAmbitionUpdatePayload = z.infer<typeof userAmbitionUpdatePayloadSchema>;
